import { Translator } from '@/utils/translate';
import { copyToClipboard } from '@/utils/copy-to-clipboard';

const MainTranslator = Translator('main');
let __uid = 1;

const requestAnimFrame =
  (typeof window !== 'undefined' && window.requestAnimationFrame && window.requestAnimationFrame.bind(window)) ||
  ((cb) => setTimeout(cb, 0));

const cancelAnimFrame =
  (typeof window !== 'undefined' && window.cancelAnimationFrame && window.cancelAnimationFrame.bind(window)) ||
  clearTimeout;

export class ViewModel {
  constructor(params = {}, element) {
    this.element = element;

    this.value = params.value || ko.observable('');
    this.disabled = params.disabled || ko.observable(false);;
    this.readonly = params.readonly || false;
    this.placeholder = params.placeholder || '';
    this.maxlength = params.maxlength || undefined;
    this.minHeight = params.minHeight || 72;
    this.maxHeight = params.maxHeight || undefined;
    this.isInvalid = params.isInvalid || false;

    this.copyable = params.copyable || false;
    this.tooltip = params.tooltip || MainTranslator.t('Скопировать в буфер');
    this.copiedText = params.copiedText || MainTranslator.t('Скопировано в буфер');
    this.statusPopperClass = params.statusPopperClass || '';
    this.targetId = `scrollable-textarea-${__uid++}`;
    this.copied = ko.observable(false);

    this.hasShadowTop = ko.observable(false);
    this.hasShadowBottom = ko.observable(false);
    this.hasScrollbar = ko.observable(false);
    this.hasCustomScrollbar = ko.observable(false);

    this.subscriptions = [];
    this._rafId = null;
    this._resizeObserver = null;

    if (ko.isObservable(this.value)) {
      this.subscriptions.push(
        this.value.subscribe(() => setTimeout(() => {
          const textarea = this.getTextarea();
          if (textarea) $(textarea).trigger('input');
          this.updateShadows();
        }, 0))
      );
    }

    setTimeout(() => {
      this.updateShadows();
      const ta = this.getTextarea();
      if (ta) {
        this._onInput = () => this.updateShadows();
        ta.addEventListener('input', this._onInput);
        ta.addEventListener('change', this._onInput);

        if (typeof ResizeObserver !== 'undefined') {
          this._resizeObserver = new ResizeObserver(() => this.updateShadows());
          this._resizeObserver.observe(ta);
        }
      }
    }, 0);

    this._onResize = () => this.updateShadows();
    window.addEventListener('resize', this._onResize);
  }

  getTextarea() {
    return this.element.querySelector('textarea');
  }

  onScroll() {
    this.updateShadows();
  }

  updateShadows() {
    if (this._rafId) {
      cancelAnimFrame(this._rafId);
    }

    this._rafId = requestAnimFrame(() => {
      this._rafId = null;
      this.applyShadows();
    });
  }

  applyShadows() {
    const el = this.getTextarea();
    if (!el) return;
    const st = el.scrollTop;
    const ch = el.clientHeight;
    const sh = el.scrollHeight;
    const epsilon = 2;
    const hasScrollbar = sh - ch > epsilon;
    this.hasScrollbar(hasScrollbar);
    if (hasScrollbar) {
      const atTop = st <= epsilon;
      const atBottom = sh - ch - st <= epsilon;
      this.hasShadowTop(!atTop);
      this.hasShadowBottom(!atBottom);
    } else {
      this.hasShadowTop(false);
      this.hasShadowBottom(false);
    }

    const width = Math.max(0, Math.round(el.offsetWidth - el.clientWidth));
    this.element.style.setProperty('--fc-scrollable-area-scrollbar-width', width + 'px');

    const isCustomScrollbar = width === 4 && this.hasScrollbar();

    if (isCustomScrollbar && this.element) {
      this.element.classList.add('scrollable-textarea--custom-scrollbar');
      this.hasCustomScrollbar(isCustomScrollbar);
    } else {
      this.element.classList.remove('scrollable-textarea--custom-scrollbar');
      this.hasCustomScrollbar(isCustomScrollbar);
    }
  }

  copy() {
    copyToClipboard(ko.toJS(this.value), this.element).then(() => {
      this.copied(true);
    });
  }

  dispose() {
    this.subscriptions.forEach((s) => s.dispose());
    const ta = this.getTextarea();
    if (ta && this._onInput) {
      ta.removeEventListener('input', this._onInput);
      ta.removeEventListener('change', this._onInput);
    }
    window.removeEventListener('resize', this._onResize);
    if (this._resizeObserver) {
      this._resizeObserver.disconnect();
      this._resizeObserver = null;
    }
    if (this._rafId) {
      cancelAnimFrame(this._rafId);
      this._rafId = null;
    }
  }
}
